<script>
export default {};
</script>

<template>
  <!--START PRICING-->
  <section class="section pt-5" id="pricing">
    <div class="container">

      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">Planos</h1>
          <div class="section-title-border margin-t-20"></div>
          <p
            class="section-subtitle font-secondary text-muted text-center padding-t-30"
          >Escolha abaixo quais dos planos cabe melhor no seu bolso. Contrate agora e em poucos minutos você já estará desfrutando o nosso catálogo.</p>
        </div>
      </div>

      <div class="row margin-t-50">
        <div class="col-lg-4">
          <div class="text-center pricing-box hover-effect">
            <h4 class="text-uppercase">30 DIAS</h4>
            <h1>R$35,00</h1>
            <h6 class="text-uppercase text-muted">+ taxa de cobrança</h6>
            <div class="pricing-border"></div>
            <div class="plan-features margin-t-30">
              <p>
                + de 
                <b class="text-custom">1.100 canais</b> (nacionais e internacionais)
              </p>
              <p>
                + de 
                <b class="text-custom">3.000 filmes</b>
                (conteúdos)
              </p>
              <p>
                + de 
                <b class="text-custom">13.000 séries</b>
                (conteúdos)
              </p>
              <p>
                
                <b class="text-custom">Suporte</b> Dedicado
              </p>
              <p>
                <b class="text-custom">Catálogo mais completo</b> do Brasil
              </p>
            </div>
            <a href="javascript: void(0);" class="btn btn-custom waves-effect waves-light margin-t-30" @click="cadastrar_plano('PACOTE 30 DIAS')">Contratar Agora!</a>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="text-center pricing-box bg-white hover-effect price-active">
            <h4 class="text-uppercase">90 DIAS</h4>
            <h1>R$93,00</h1>
            <h6 class="text-uppercase text-muted">+ taxa de cobrança</h6>
            <div class="pricing-border"></div>
            <div class="plan-features margin-t-30">
              <p>
                + de 
                <b class="text-custom">1.100 canais</b> (nacionais e internacionais)
              </p>
              <p>
                + de 
                <b class="text-custom">3.000 filmes</b>
                (conteúdos)
              </p>
              <p>
                + de 
                <b class="text-custom">13.000 séries</b>
                (conteúdos)
              </p>
              <p>
                
                <b class="text-custom">Suporte</b> Dedicado
              </p>
              <p>
                <b class="text-custom">Catálogo mais completo</b> do Brasil
              </p>
            </div>
            <a href="javascript: void(0);" class="btn btn-custom waves-effect waves-light margin-t-30" @click="cadastrar_plano('PACOTE 90 DIAS')">Contratar Agora!</a>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="text-center pricing-box hover-effect">
            <h4 class="text-uppercase">180 DIAS</h4>
            <h1>R$170,00</h1>
             <h6 class="text-uppercase text-muted">+ taxa de cobrança</h6>
            <div class="pricing-border"></div>
            <div class="plan-features margin-t-30">
              <p>
                + de 
                <b class="text-custom">1.100 canais</b> (nacionais e internacionais)
              </p>
              <p>
                + de 
                <b class="text-custom">3.000 filmes</b>
                (conteúdos)
              </p>
              <p>
                + de 
                <b class="text-custom">13.000 séries</b>
                (conteúdos)
              </p>
              <p>
                
                <b class="text-custom">Suporte</b> Dedicado
              </p>
              <p>
                <b class="text-custom">Catálogo mais completo</b> do Brasil
              </p>
            </div>
            <a href="javascript: void(0);" class="btn btn-custom waves-effect waves-light margin-t-30" @click="cadastrar_plano('PACOTE 180 DIAS')">Contratar Agora!</a>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">Planos</h1>
          <div class="section-title-border margin-t-20"></div>
          <p
            class="section-subtitle font-secondary text-muted text-center padding-t-30"
          >Todos os planos acima são de 1 acesso simultâneo. Consulta valores especiais de mais conexões simultânea com nossa equipe.</p>
        </div>
      </div>
      

    </div>
  </section>
  <!--ENd PRICING-->
</template>

<script>
export default {
  
  methods: {

    cadastrar_plano(plano){
      return this.$ilimitada.cadastrar_plano(plano);
    }
  }
  
}
</script>